export default __webpack_public_path__ + "static/media/contact_support_icon.0df199c3.svg";